import React from 'react';
import Box from '@mui/material/Box';
import TwDialog from '../../../components/TwDialog/TwDialog';
import useNotifications from '../../../providers/Notifications/Notifications.provider';
import { TwButton, TwButtonType } from '../../../components/TwButtons/TwButtons';
import { ReactComponent as WarningSign } from '../../../assets/warning-sign.svg';
import { useDeleteOtherExpenseMutation } from '../../../redux/api/otherExpenses/otherExpenseApi';

export interface DeleteExpenseProps {
  open: boolean;
  expenseId: string | null;
  expenseName: string;
  equipmentName?: string;
  onClose: (changed: boolean) => void;
  onSuccess?: () => void;
}

const DeleteExpense: React.FC<DeleteExpenseProps> = ({
  open,
  expenseId,
  expenseName,
  equipmentName,
  onClose,
  onSuccess
}): JSX.Element => {
  const [deleteExpense] = useDeleteOtherExpenseMutation();
  const { addNotification } = useNotifications();

  const getDeleteMessage = (): JSX.Element => {
    return equipmentName ? (
      <span>
        Are you sure you want to delete <b>{expenseName}</b> for <b>{equipmentName}</b>? You can’t
        undo this action.
      </span>
    ) : (
      <span>
        Are you sure you want to delete <b>{expenseName}</b>? You can’t undo this action.
      </span>
    );
  };

  const handleDeleteExpense = (): void => {
    if (!expenseId) return;

    deleteExpense(expenseId)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        onClose(true);
        addNotification({
          message: 'Expense deleted successfully',
          variant: 'success',
          timeToShow: 5000
        });
      })
      .catch(() => {
        onClose(false);
        addNotification({
          message: 'Error deleting expense',
          variant: 'error',
          timeToShow: 5000
        });
      });
  };

  if (!expenseId) {
    return <></>;
  }

  return (
    <TwDialog
      size="xs"
      title="Delete expense?"
      open={open}
      onClickClose={(): void => onClose(false)}
      actions={[
        <TwButton
          key="1"
          type={TwButtonType.secondary}
          label="Cancel"
          action={(): void => onClose(false)}
        />,
        <TwButton
          key="2"
          type={TwButtonType.negative}
          label="Delete"
          action={(): void => {
            handleDeleteExpense();
          }}
        />
      ]}
    >
      <Box component="div" className="equipment__confirmation-dialog-content">
        <WarningSign />
        <span className="equipment__confirmation-dialog-text">{getDeleteMessage()}</span>
      </Box>
    </TwDialog>
  );
};

export default DeleteExpense;
